module.exports = __webpack_public_path__ + "static/hexportal-5181237453a19aecd296ece95295d817.png";